var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast"}},[(_vm.show)?_c('div',{staticClass:"toast",class:_vm.type},[_c('div',{staticClass:"toast-content"},[(_vm.type === 'success')?_c('i',{staticClass:"fas fa-check-circle"}):(_vm.type === 'loading')?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }